import { combineReducers } from 'redux'
import misc from './misc'
import notifications from './notifications'

export default combineReducers({
  misc,
  notifications,
})
